import { WorkflowVersion } from "@/components/Workflows/types";
import { ListPromptVersion } from "@/types";

const useVersionDetails = (version: WorkflowVersion | ListPromptVersion) => {
  const { id, created_at, commit_message, number, labels } = version;
  const author = "user_email" in version ? version.user_email : version.author;
  const hasReportId = "report_id" in version && version.report_id;

  return {
    id,
    created_at,
    commit_message,
    number,
    labels,
    author,
    hasReportId,
    reportId: hasReportId ? version.report_id : null,
  };
};

export default useVersionDetails;
